module.exports = __webpack_public_path__ + "static/media/mainheroimg.59aec240.png";